(function () {
    toast = function (text, type) {
        var $toast = $('<div class="toast alert alert-' + (type || 'success') + '">' + '<i class="fas fa-exclamation-circle"></i>' + text + '</div>');
        $(document.body).append($toast);
        setTimeout(function () { $toast.addClass('toast-hidden') }, 3000);
    }
})();